// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"934b39ba","453":"609ae681"}[chunkId] + ".chunk.js";
};